import { createVNode as _createVNode } from "vue";
import "core-js/modules/esnext.iterator.map.js";
import { BASE_URL, PAGE_URL, remove } from "@/api/system/menu-action";
import { createFormItem } from "@/component-create/utils/create-form-item";
import { createTableActionItem, createTableColumn, createTableHeaderButton } from "@/component-create/utils/create-table-column";
import { Dialog } from "@/component-create/Dialog";
import { FormDialog } from "@/component-create/FormDialog";
import { SearchForm } from "@/component-create/SearchForm";
import { Table } from "@/component-create/Table";
import { FORM_ITEM } from "@/components/form/enums";
import { MENU_ACTION_STATUS } from "@/constant/system/code";
import { formatter, isOnlyOne } from "@/utils/common";
import { deleteBox, toast } from "@/utils/message";
import { AUTHORITY_CODE } from "@/utils/pattern";
export function renderActionDialog(el) {
  const dialog = new Dialog(el, MenuActionConponent, '菜单操作管理', '60%', []);
  return dialog;
}
const MenuActionConponent = defineComponent({
  props: ['menuId'],
  setup(props, ctx) {
    const searchRef = ref();
    const tableRef = ref();
    const addRef = ref();
    const editRef = ref();
    let searchForm = null;
    let table = null;
    let addForm = null;
    let editForm = null;
    watch(() => props.menuId, newVal => {
      if (table) {
        table.setTableData([]);
        table.setRequestData({
          menuId: newVal
        });
        table.load({
          menuId: newVal
        });
      }
      if (addForm) {
        addForm.setSaveParams({
          menuId: props.menuId
        });
      }
      if (editForm) {
        editForm.setSaveParams({
          menuId: props.menuId
        });
      }
    }, {
      immediate: true
    });
    onMounted(() => {
      renderSearchForm();
      renderAddForm();
      renderEditForm();
      renderTable();
    });
    function renderTable() {
      table = new Table(tableRef.value, [{
        type: 'selection'
      }, {
        type: 'index',
        label: '序号',
        width: '60'
      }, createTableColumn('操作名称', 'actionName'), createTableColumn('权限代码', 'authorityCode'), createTableColumn('状态', 'status', '60', 'center', {
        formatter: row => formatter(MENU_ACTION_STATUS, row.status)
      }), createTableColumn('备注', 'remark', undefined, undefined, {
        showOverflowTooltip: true
      }), createTableColumn('操作', 'remark', '150', 'center', {
        controller: [createTableActionItem('编辑', 'Edit', row => {
          editForm?.open(row.id);
        }), createTableActionItem('删除', 'Delete', row => {
          deleteBox().then(() => {
            remove([row.id]).then(() => {
              toast.success('删除成功');
              table?.load();
            });
          });
        })]
      })], [createTableHeaderButton('新增', 'primary', 'Plus', () => {
        addForm?.open();
      }), createTableHeaderButton('编辑', 'primary', 'Edit', rows => {
        if (isOnlyOne(rows)) {
          editForm?.open(rows[0].id);
        }
      }), createTableHeaderButton('删除', 'primary', 'Delete', rows => {
        deleteBox().then(() => {
          remove(rows.map(item => item.id)).then(() => {
            toast.success('删除成功');
            table?.load();
          });
        });
      })], {
        border: true
      }, PAGE_URL, {
        requestData: {
          menuId: props.menuId
        }
      });
    }
    function renderSearchForm() {
      searchForm = new SearchForm(searchRef.value, [createFormItem('操作名称', 'actionName', FORM_ITEM.INPUT, {
        clearable: true
      }), createFormItem('权限代码', 'authorityCode', FORM_ITEM.INPUT, {
        clearable: true
      }), createFormItem('状态', 'status', FORM_ITEM.SELECT, {
        loader: 'MENU_ACTION_STATUS',
        default: true,
        allOption: true
      })]);
      searchForm.onSearch = formData => {
        table?.load(formData);
      };
      searchForm.onReset = () => {
        table?.load({});
      };
    }
    function renderAddForm() {
      addForm = new FormDialog(addRef.value, {
        items: [[createFormItem('操作名称', 'actionName', FORM_ITEM.INPUT, {
          clearable: true
        })], [createFormItem('权限代码', 'authorityCode', FORM_ITEM.INPUT, {
          clearable: true
        })], [createFormItem('状态', 'status', FORM_ITEM.SELECT, {
          loader: 'MENU_ACTION_STATUS',
          default: true
        }), null], [createFormItem('备注', 'remark', FORM_ITEM.INPUT, {
          type: 'textarea',
          rows: 3,
          maxlength: '200',
          showWordLimit: true
        })]],
        saveUrl: BASE_URL,
        elFormProps: {
          rules: {
            actionName: [{
              required: true,
              message: '请输入操作名称',
              trigger: 'blur'
            }],
            authorityCode: [{
              required: true,
              message: '请输入权限代码',
              trigger: 'blur'
            }, {
              pattern: AUTHORITY_CODE,
              required: true,
              message: '只能包含字母、数字、冒号、短横线',
              trigger: 'blur'
            }],
            status: [{
              required: true,
              message: '请选择操作状态',
              trigger: 'blur'
            }]
          }
        }
      }, '新增');
      addForm.setSaveParams({
        menuId: props.menuId
      });
      addForm.onSaveSuccess = () => {
        table?.load();
      };
    }
    function renderEditForm() {
      editForm = new FormDialog(editRef.value, {
        items: [[createFormItem('操作名称', 'actionName', FORM_ITEM.INPUT, {
          clearable: true
        })], [createFormItem('权限代码', 'authorityCode', FORM_ITEM.INPUT, {
          clearable: true
        })], [createFormItem('状态', 'status', FORM_ITEM.SELECT, {
          loader: 'MENU_ACTION_STATUS',
          default: true
        }), null], [createFormItem('备注', 'remark', FORM_ITEM.INPUT, {
          type: 'textarea',
          rows: 3,
          maxlength: '200',
          showWordLimit: true
        })]],
        saveUrl: BASE_URL,
        loadUrl: BASE_URL,
        saveMethods: 'put',
        elFormProps: {
          rules: {
            actionName: [{
              required: true,
              message: '请输入操作名称',
              trigger: 'blur'
            }],
            authorityCode: [{
              required: true,
              message: '请输入权限代码',
              trigger: 'blur'
            }, {
              pattern: AUTHORITY_CODE,
              required: true,
              message: '只能包含字母、数字、冒号、短横线',
              trigger: 'blur'
            }],
            status: [{
              required: true,
              message: '请选择操作状态',
              trigger: 'blur'
            }]
          }
        }
      });
      editForm.setSaveParams({
        menuId: props.menuId
      });
      editForm.onSaveSuccess = () => {
        table?.load();
      };
    }
    function __close() {
      searchForm?.reset();
    }
    ctx.expose({
      __close
    });
    return () => _createVNode("div", null, [_createVNode("div", {
      "ref": searchRef
    }, null), _createVNode("div", {
      "ref": tableRef
    }, null), _createVNode("div", {
      "ref": addRef
    }, null), _createVNode("div", {
      "ref": editRef
    }, null)]);
  }
});